import { Component, Emit } from 'vue-property-decorator';
import { ControlPositionModel } from '../../types';
import ControlComponent from './control';

@Component
export default class ColorLightComponent extends ControlComponent {

    @Emit()
    colorSelectionRequested(_controlPosition: ControlPositionModel) {
    }

    handleClick() {
        this.colorSelectionRequested(this.control);
    }
}
